import { getStartedStartup } from 'api/calls/authCalls';
import { ConstitutionStatusOption } from 'components/types';
import React, { useCallback, useMemo, useState, useEffect, FC, createContext } from 'react';
import { PLANS, PLANS_value } from '../../../../../shared/const';
import { ContextProviderProps, StepperContextStartUpType } from '../../../../types/Context';
import { OptionTypes } from '../../../../types/types';
import { Address } from 'components/types/Api';

const initialState: StepperContextStartUpType = {
    //general info
    plans: [],
    setPlans: () => { },
    sectors: [],
    setSectors: () => { },
    constitutionStatuses: [],
    setConstitutionStatuses: () => { },
    generalInfo: { section1: "", section2: "", section3: "", terms: "", privacy: "" },
    setGeneralInfo: () => { },

    // user Info
    firstName: "",
    setFirstName: () => { },
    lastName: "",
    setLastName: () => { },
    email: "",
    setEmail: () => { },
    phoneNumber: "",
    setPhoneNumber: () => { },
    password: "",
    setPassword: () => { },
    confirmPassword: "",
    setConfirmPassword: () => { },

    //start Up Info
    startUpName: "",
    setStartUpName: () => { },
    // website: "",
    // setWebSite: () => { },
    companyName: "",
    setCompanyName: () => { },
    vatNumber: "",
    setVatNumber: () => { },
    address: {
        value: "", label: "", isInItaly: false
        // city:"",country:""
    },
    setAddress: () => { },
    country: "",
    setCountry: () => { },
    city: "",
    setCity: () => { },
    sdi: "",
    setSdi: () => { },
    pec: "",
    setPec: () => { },
    state: { value: "", label: "", toValidate: true },
    setState: () => { },
    sector: { value: "", label: "" },
    setSector: () => { },

    // response
    selectedPlan: { value: "", label: "" },
    setSelectedPlan: () => { },
    termsChecked: false,
    setTermsChecked: () => { },
    privacyChecked: false,
    setPrivacyChecked: () => { },
}

export const StartUpStepperContext = createContext<StepperContextStartUpType>(initialState);

export const StartUpStepperContextProvider = ({ children }: ContextProviderProps) => {
    //general info
    const [plans, setPlans] = useState<OptionTypes[]>(initialState.plans)
    const [sectors, setSectors] = useState<OptionTypes[]>(initialState.plans)
    const [constitutionStatuses, setConstitutionStatuses] = useState<ConstitutionStatusOption[]>(initialState.constitutionStatuses)
    const [generalInfo, setGeneralInfo] = useState(initialState.generalInfo)

    // user Info
    const [firstName, setFirstName] = useState(initialState.firstName)
    const [lastName, setLastName] = useState(initialState.lastName)
    const [email, setEmail] = useState(initialState.email)
    const [phoneNumber, setPhoneNumber] = useState(initialState.phoneNumber)
    const [password, setPassword] = useState(initialState.password)
    const [confirmPassword, setConfirmPassword] = useState(initialState.confirmPassword)

    //start Up Info
    const [startUpName, setStartUpName] = useState(initialState.startUpName)
    // const [website, setWebSite] = useState(initialState.website)
    const [companyName, setCompanyName] = useState(initialState.companyName)
    const [vatNumber, setVatNumber] = useState(initialState.vatNumber)
    const [address, setAddress] = useState<Address | null>(null)
    const [country, setCountry] = useState(initialState.country)
    const [city, setCity] = useState(initialState.city)
    const [sdi, setSdi] = useState(initialState.sdi)
    const [pec, setPec] = useState(initialState.pec)
    const [state, setState] = useState<ConstitutionStatusOption>(initialState.state)
    const [sector, setSector] = useState<OptionTypes>(initialState.sector)

    // response
    const [selectedPlan, setSelectedPlan] = useState<OptionTypes>(initialState.selectedPlan)
    const [termsChecked, setTermsChecked] = useState(false)
    const [privacyChecked, setPrivacyChecked] = useState(false)

    useEffect(() => {
        getStartedStartup()
            .then(({ response }) => {
                if (!response) return
                setSectors(response.sectors);
                setPlans(response.plans);
                setConstitutionStatuses(response.statuses);
                setGeneralInfo(response.termsText);
            })
    }, [])

    const startUpStepperCtx: StepperContextStartUpType = {
        // general info
        sectors, setSectors,
        plans, setPlans,
        sector, setSector,
        constitutionStatuses, setConstitutionStatuses,
        generalInfo, setGeneralInfo,

        // user Info
        firstName, setFirstName,
        lastName, setLastName,
        email, setEmail,
        phoneNumber, setPhoneNumber,
        password, setPassword,
        confirmPassword, setConfirmPassword,

        //start Up Info
        startUpName, setStartUpName,
        // website, setWebSite,
        companyName, setCompanyName,
        vatNumber, setVatNumber,
        address, setAddress,
        country, setCountry,
        city, setCity,
        sdi, setSdi,
        pec, setPec,
        state, setState,

        // response
        selectedPlan, setSelectedPlan,
        termsChecked, setTermsChecked,
        privacyChecked, setPrivacyChecked
    }

    return (
        <StartUpStepperContext.Provider value={startUpStepperCtx}>
            {children}
        </StartUpStepperContext.Provider>
    )
}
